<!-- Selectors -->
<div *ngIf="showSelectors$ | async" class="container">
    <form [formGroup]="form">
        <div *ngIf="!isResidentialAreaSelected" class="row mt-4">
            <span
                class="col p-0 pe-5 me-1 mt-3 fw-bold text-start text-md-start"
            >
                {{ 'specify-residential-area-message' | cmsText | async }}
            </span>
        </div>
        <div class="row">
            <div class="col-md-6 col-12 row mt-3">
                <label
                    class="form-label col-6 text-end"
                    for="prefecture-selector"
                >
                    {{ 'home-prefecture-selector-label' | cmsText | async }}
                </label>
                <div class="col-6">
                    <ng-select
                        id="prefectureSelector"
                        [items]="prefectures$ | async"
                        [selectOnTab]="true"
                        formControlName="prefecture"
                        bindLabel="name"
                    >
                    </ng-select>
                </div>
            </div>
            <div
                class="col-md-6 col-12 row mt-3 mb-2"
                [ngClass]="{ 'mb-3': !isResidentialAreaSelected }"
            >
                <label class="form-label col-6 text-end" for="city-selector">
                    {{ 'home-city-selector-label' | cmsText | async }}
                </label>
                <div class="col-6">
                    <ng-select
                        id="citySelector"
                        [items]="cities$ | async"
                        [selectOnTab]="true"
                        formControlName="city"
                        bindLabel="name"
                        groupBy="prefectureNameJP"
                        [readonly]="citySelectorReadonly"
                    >
                        <ng-template ng-optgroup-tmp let-item="item">
                            <span class="text-primary">{{
                                item.prefectureNameJP
                            }}</span>
                        </ng-template>
                    </ng-select>
                </div>
            </div>
        </div>
    </form>
    <div class="row">
        <div
            *ngIf="isResidentialAreaSelected"
            class="col alert alert-warning mb-4"
        >
            {{ 'residential-area-selected-alert' | cmsText | async }}
        </div>
    </div>
</div>

<!-- Desktop hero -->
<div
    class="fluid-container hero-image mt-md-0 d-none d-sm-block"
    [ngStyle]="{ 'background-image': 'url(' + (hero$ | async) + ')' }"
>
    <div class="container">
        <div class="row">
            <div class="col-6 offset-3 text-center d-none d-sm-block">
                <img
                    class="img-fluid my-3 header-image-logo"
                    [attr.src]="'header-image-logo' | cmsImageSrc | async"
                    [attr.alt]="'header-image-logo' | cmsImageAlt | async"
                />
            </div>
            <div
                class="col-sm-3 col-4 offset-sm-0 offset-8 text-end"
                *ngIf="
                    contentService.valueExists('community-image-mascot') | async
                "
            >
                <img
                    class="community-image-mascot mt-3"
                    [attr.src]="'community-image-mascot' | cmsImageSrc | async"
                    [attr.alt]="'community-image-mascot' | cmsImageAlt | async"
                />
            </div>
        </div>
    </div>
</div>
<!-- Mobile hero -->
<div
    class="fluid-container hero-image mt-md-0 d-block d-sm-none"
    [ngStyle]="{ 'background-image': 'url(' + (heroMobile$ | async) + ')' }"
>
    <div class="container">
        <div class="row">
            <div class="col-6 offset-3 text-center d-none d-sm-block">
                <img
                    class="img-fluid my-3 header-image-logo"
                    [attr.src]="'header-image-logo' | cmsImageSrc | async"
                    [attr.alt]="'header-image-logo' | cmsImageAlt | async"
                />
            </div>
            <div
                class="col-sm-3 col-4 offset-sm-0 offset-8 text-end"
                *ngIf="
                    contentService.valueExists('community-image-mascot') | async
                "
            >
                <img
                    class="community-image-mascot mt-3"
                    [attr.src]="'community-image-mascot' | cmsImageSrc | async"
                    [attr.alt]="'community-image-mascot' | cmsImageAlt | async"
                />
            </div>
        </div>
    </div>
</div>

<div class="container">
    <div class="row" *ngIf="this.registrationEnabled$ | async">
        <div class="col-xl-11 col-12 mx-auto">
            <div class="card border-0 mt-sm-n5 mt-n3 border-0 shadow">
                <div class="card-body">
                    <div
                        *ngIf="
                            contentService.valueExists('header-image-logo-alt')
                                | async
                        "
                        class="mx-auto text-center bg-light rounded mb-3 d-sm-none d-xs-block"
                    >
                        <img
                            class="img-fluid my-xl-5 header-image-logo"
                            [attr.src]="
                                'header-image-logo-alt' | cmsImageSrc | async
                            "
                            [attr.alt]="
                                'header-image-logo-alt' | cmsImageAlt | async
                            "
                        />
                    </div>
                    <div class="row">
                        <div class="col-xl-9 col-12 my-auto text-center">
                            <p
                                class="lead card-title"
                                [innerHTML]="
                                    'hero-card-' +
                                        (phaseService.getCmsAppendString$
                                            | async) +
                                        'text'
                                        | cmsText
                                        | jpText
                                        | async
                                "
                            ></p>
                        </div>
                        <div class="col text-center">
                            <button
                                id="homeRegisterBtn"
                                [disabled]="
                                    !(
                                        registrationService.enableRegistrationFlow$
                                        | async
                                    ) ||
                                    (isLoadingRegister && registerButtonClicked)
                                "
                                class="btn btn-primary btn-xs-block px-5 text-uppercase mt-3 mt-xl-0"
                                (click)="registerButtonClicked = true"
                                [routerLink]="'../register'"
                                gaEvent
                                [gaPage]="{
                                    path:
                                        this.communityService.communityCode +
                                        '/home',
                                }"
                                [gaActivity]="{
                                    category: 'register-button',
                                    action: 'click',
                                }"
                            >
                                <i
                                    *ngIf="
                                        isLoadingRegister &&
                                        registerButtonClicked
                                    "
                                    class="fa fa-spinner fa-spin me-1"
                                ></i>
                                <span
                                    [innerHTML]="
                                        'register-' +
                                            (phaseService.getCmsAppendString$
                                                | async) +
                                            'button-text'
                                            | cmsText
                                            | jpText
                                            | async
                                    "
                                ></span>
                                <i class="fa fa-chevron-right ms-2"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div
        *ngIf="interestedIndividualEnabled$ | async"
        class="row mt-3 align-items-center h5 text-center justify-content-around alert alert-warning"
    >
        <span
            [innerHTML]="'auction-did-not-start-message' | cmsText | async"
        ></span>
    </div>

    <div
        *ngIf="
            !(interestedIndividualEnabled$ | async) &&
            (contentService.valueExists('auction-start-welcome-message')
                | async)
        "
        class="row mt-3 align-items-center h5 text-center justify-content-around alert alert-warning"
    >
        <span
            [innerHTML]="'auction-start-welcome-message' | cmsText | async"
        ></span>
    </div>

    <div class="my-5" *ngIf="contentService.valueExists('hero-title') | async">
        <h1
            class="py-3 text-center text-primary fw-bold"
            [innerHTML]="'hero-title' | cmsText | jpText | async"
        ></h1>
    </div>
</div>

<section class="fluid-container my-lg-0 py-3 my-3">
    <div class="container">
        <div class="mx-auto">
            <div class="d-flex flex-md-row flex-column justify-content-center">
                <div class="col-md-3">
                    <img
                        class="img-fluid my-auto p-md-0 p-3"
                        [attr.src]="'group-logo' | cmsImageSrc | async"
                        [attr.alt]="'group-logo' | cmsImageAlt | async"
                    />
                </div>
                <div class="col-md-6 my-auto text-md-left">
                    <app-counter variant="home"></app-counter>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="fluid-container bg-light py-5">
    <div class="container">
        <h3 class="mb-0 mb-md-5 mb-5 text-center">
            <span
                [innerHTML]="'home-group-buying-info-title' | cmsText | async"
            ></span>
        </h3>
        <div class="row">
            <div class="col-lg-7 my-lg-auto my-3">
                <div
                    [innerHTML]="
                        'home-group-buying-info-text' | cmsText | jpText | async
                    "
                ></div>
            </div>
            <div
                class="col-lg-5 border-width-2 border-dashed p-3 my-lg-auto my-3 mx-lg-0 mx-3"
            >
                <h6
                    [innerHTML]="
                        'home-group-buying-info-list-title'
                            | cmsText
                            | jpText
                            | async
                    "
                ></h6>
                <ol class="ps-4 m-0">
                    <li
                        *ngIf="
                            contentService.valueExists(
                                'home-group-buying-info-list-line-1'
                            ) | async
                        "
                        [innerHTML]="
                            'home-group-buying-info-list-line-1'
                                | cmsText
                                | jpText
                                | async
                        "
                    ></li>
                    <li
                        *ngIf="
                            contentService.valueExists(
                                'home-group-buying-info-list-line-2'
                            ) | async
                        "
                        [innerHTML]="
                            'home-group-buying-info-list-line-2'
                                | cmsText
                                | jpText
                                | async
                        "
                    ></li>
                    <li
                        *ngIf="
                            contentService.valueExists(
                                'home-group-buying-info-list-line-3'
                            ) | async
                        "
                        [innerHTML]="
                            'home-group-buying-info-list-line-3'
                                | cmsText
                                | jpText
                                | async
                        "
                    ></li>
                    <li
                        *ngIf="
                            contentService.valueExists(
                                'home-group-buying-info-list-line-4'
                            ) | async
                        "
                        [innerHTML]="
                            'home-group-buying-info-list-line-4'
                                | cmsText
                                | jpText
                                | async
                        "
                    ></li>
                </ol>
            </div>
        </div>
    </div>
</section>

<section class="fluid-container mt-3">
    <div class="container pb-md-5 pt-md-4">
        <div class="row pb-md-4 pt-md-5">
            <div class="d-sm-grid gap-4 d-sm-flex">
                <div
                    *ngFor="let item of infoBullets"
                    class="card link-box col-sm-4 col-12 my-md-0 my-5 hoverable"
                >
                    <a [routerLink]="item.routerLink">
                        <div
                            class="col-xl-5 col-lg-6 col-md-8 col-sm-10 col-5 mx-auto card-icon"
                        >
                            <div class="link-box-icon-border">
                                <img
                                    class="rounded-circle img-fluid link-box-icon"
                                    [attr.src]="
                                        'hero-bullet-' + item.id + '-img'
                                            | cmsImageSrc
                                            | async
                                    "
                                    [attr.alt]="
                                        'hero-bullet-' + item.id + '-img'
                                            | cmsImageAlt
                                            | async
                                    "
                                />
                            </div>
                        </div>
                        <div class="pt-2 pb-4 px-md-2">
                            <i class="fa fa-chevron-right float-end"></i>
                            <h3
                                class="card-title h6 fw-bold link-box-title text-md-center mt-3"
                                [innerHTML]="
                                    'hero-bullet-' + item.id + '-title'
                                        | cmsText
                                        | jpText
                                        | async
                                "
                            ></h3>
                            <p
                                class="card-text link-box-text"
                                [innerHTML]="
                                    'hero-bullet-' + item.id + '-text'
                                        | cmsText
                                        | jpText
                                        | async
                                "
                            ></p>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="fluid-ceontainer bg-light py-5">
    <div class="container">
        <div class="col-md-9 mx-auto">
            <div class="row">
                <div class="col-md-5 col-sm-5 col-6 offset-3 offset-sm-0">
                    <img
                        class="img-fluid my-auto"
                        [attr.src]="'webinar-logo' | cmsImageSrc | async"
                        [attr.alt]="'webinar-logo' | cmsImageAlt | async"
                    />
                </div>
                <div
                    class="col-md-7 col-sm-7 col-12 my-auto"
                    [innerHTML]="'home-group-text' | cmsText | jpText | async"
                ></div>
            </div>
        </div>
    </div>
</section>

<section
    *ngIf="contentService.valueExists('home-quote-text') | async"
    class="container"
>
    <div
        *ngIf="contentService.valueExists('home-quote-notice-text') | async"
        class="col border border-dark mt-5 p-3"
        [innerHTML]="'home-quote-notice-text' | cmsText | jpText | async"
    ></div>
    <div
        [ngClass]="{
            'mx-auto': true,
            'col-md-12': (showSecondQuote$ | async),
            'col-md-9': !(showSecondQuote$ | async),
        }"
    >
        <div class="row">
            <!-- First quote -->
            <div
                [ngClass]="{
                    'col-12 my-5': true,
                    'col-md-6': (showSecondQuote$ | async),
                }"
            >
                <div class="row">
                    <div
                        class="col-6 col-sm-2 text-center mb-3 mb-md-0"
                        *ngIf="showSecondImage$ | async"
                    >
                        <img
                            class="img-fluid"
                            [attr.alt]="
                                'home-quote-image' | cmsImageAlt | async
                            "
                            [attr.src]="
                                'home-quote-image' | cmsImageSrc | async
                            "
                        />
                    </div>
                    <div
                        class="col-6 col-sm-2 text-center mb-3 mb-md-0"
                        *ngIf="showSecondImage$ | async"
                    >
                        <img
                            class="img-fluid"
                            [attr.alt]="
                                'home-quote-image-2' | cmsImageAlt | async
                            "
                            [attr.src]="
                                'home-quote-image-2' | cmsImageSrc | async
                            "
                        />
                    </div>
                    <div
                        class="col-6 col-sm-3 text-center mb-3 mb-md-0"
                        *ngIf="!(showSecondImage$ | async)"
                    >
                        <img
                            class="img-fluid"
                            [attr.alt]="
                                'home-quote-image' | cmsImageAlt | async
                            "
                            [attr.src]="
                                'home-quote-image' | cmsImageSrc | async
                            "
                        />
                    </div>
                    <div class="col-12 col-sm-8 my-auto">
                        <div
                            class="lead"
                            [innerHTML]="
                                'home-quote-text' | cmsText | jpText | async
                            "
                        ></div>
                        <span
                            class="text-muted text-end"
                            [innerHTML]="
                                'home-quote-footer' | cmsText | jpText | async
                            "
                        >
                        </span>
                    </div>
                </div>
            </div>

            <!-- Second quote (optional) -->
            <div class="col-md-6 col-12 my-5" *ngIf="showSecondQuote$ | async">
                <div class="row">
                    <div class="col-6 col-sm-3 text-center mb-3 mb-md-0">
                        <img
                            class="rounded-circle img-fluid"
                            [attr.alt]="
                                'home-second-quote-image' | cmsImageAlt | async
                            "
                            [attr.src]="
                                'home-second-quote-image' | cmsImageSrc | async
                            "
                        />
                    </div>
                    <div class="col-12 col-sm-9 my-auto">
                        <div
                            class="lead"
                            [innerHTML]="
                                'home-second-quote-text'
                                    | cmsText
                                    | jpText
                                    | async
                            "
                        ></div>
                        <span
                            class="text-muted text-end"
                            [innerHTML]="
                                'home-second-quote-footer'
                                    | cmsText
                                    | jpText
                                    | async
                            "
                        >
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="fluid-container bg-light py-5">
    <div class="container">
        <div [ngClass]="{ row: true, 'bg-white': showVideo$ | async }">
            <div class="col-md-5 p-3" *ngIf="showVideo$ | async">
                <div
                    class="embed-responsive rounded"
                    [youtubemovie]="'home-page-youtube-video' | cmsText | async"
                ></div>
            </div>
            <div
                [ngClass]="{
                    'col-md-7': showVideo$ | async,
                    'col-md-8': !(showVideo$ | async),
                    'bg-white': true,
                    rounded: true,
                    'p-4': true,
                    'text-center': true,
                    'ms-auto': true,
                    'me-auto': true,
                }"
            >
                <h3 class="mb-4">
                    {{ 'why-signup-title' | cmsText | jpText | async }}
                </h3>
                <div class="d-flex align-items-start">
                    <div
                        *ngIf="!(showVideo$ | async)"
                        class="col-1 col-lg-2 d-md-block d-none"
                    ></div>
                    <i class="text-primary fa fa-check me-2 mt-2 fa-lg"></i>
                    <div
                        class="text-left"
                        [innerHTML]="'why-signup-bullet-1-md' | cmsText | async"
                    ></div>
                </div>
                <div class="d-flex align-items-start">
                    <div
                        *ngIf="!(showVideo$ | async)"
                        class="col-1 col-lg-2 d-md-block d-none"
                    ></div>
                    <i class="text-primary fa fa-check me-2 mt-2 fa-lg"></i>
                    <div
                        class="text-left"
                        [innerHTML]="'why-signup-bullet-2-md' | cmsText | async"
                    ></div>
                </div>
                <div class="d-flex align-items-start">
                    <div
                        *ngIf="!(showVideo$ | async)"
                        class="col-1 col-lg-2 d-md-block d-none"
                    ></div>
                    <i class="text-primary fa fa-check me-2 mt-2 fa-lg"></i>
                    <div
                        class="text-left"
                        [innerHTML]="'why-signup-bullet-3-md' | cmsText | async"
                    ></div>
                </div>
                <div class="d-flex align-items-start">
                    <div
                        *ngIf="!(showVideo$ | async)"
                        class="col-1 col-lg-2 d-md-block d-none"
                    ></div>
                    <i class="text-primary fa fa-check me-2 mt-2 fa-lg"></i>
                    <div
                        class="text-left"
                        [innerHTML]="'why-signup-bullet-4-md' | cmsText | async"
                    ></div>
                </div>
                <div
                    *ngIf="
                        contentService.valueExists('why-signup-text') | async
                    "
                    class="d-flex align-items-start"
                >
                    <div
                        *ngIf="!(showVideo$ | async)"
                        class="col-1 col-lg-2 d-md-block d-none"
                    ></div>
                    <i
                        class="text-primary fa fa-check me-2 mt-2 fa-lg invisible"
                    ></i>
                    <div
                        class="text-left"
                        [innerHTML]="'why-signup-text' | cmsText | async"
                    ></div>
                </div>
                <a
                    [routerLink]="'../info/what-is-this-program'"
                    class="btn btn-outline-primary text-uppercase mx-auto px-5 my-3"
                >
                    {{
                        'what-is-this-program-info-button-text'
                            | cmsText
                            | async
                    }}<i class="fa fa-chevron-right ms-2"></i>
                </a>
            </div>
        </div>
    </div>
</section>

<section class="fluid-container text-left text-center my-5">
    <div class="container">
        <h3 class="mb-0 mb-md-5 mb-5">
            <span [innerHTML]="'how-it-works-title' | cmsText | async"></span>
        </h3>
        <div class="d-flex justify-content-between row">
            <div
                *ngFor="let item of [1, 2, 3, 4]"
                class="col-md-3 col-12 my-3 my-md-0"
            >
                <div
                    class="row"
                    *ngIf="
                        contentHelperService.getFullKeyNameIfExists(
                            'how-it-works-bullet-' + item + '-title'
                        ) | async as cmsKey
                    "
                >
                    <div class="col-md-7 col-3 mx-auto">
                        <img
                            class="img-fluid rounded-circle bg-light p-3"
                            [attr.src]="
                                'how-it-works-bullet-' + item + '-img'
                                    | cmsImageSrc
                                    | async
                            "
                            [attr.alt]="
                                'how-it-works-bullet-' + item + '-img'
                                    | cmsImageAlt
                                    | async
                            "
                        />
                    </div>
                    <div class="col-md-12 col-9 my-auto">
                        <h3 class="h6 fw-bold mt-0 mt-md-3">
                            <span
                                [innerHTML]="cmsKey | cmsText | jpText | async"
                            ></span>
                        </h3>
                        <p>
                            <span
                                [innerHTML]="
                                    contentHelperService.getFullKeyNameIfExists(
                                        'how-it-works-bullet-' + item + '-text'
                                    )
                                        | async
                                        | cmsText
                                        | async
                                "
                            ></span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-5 text-center">
            <a
                [routerLink]="'../info/how-does-it-work'"
                id="moreInfo"
                class="btn btn-outline-primary text-uppercase ms-auto me-auto px-5"
            >
                {{ 'more-info-button-text' | cmsText | async
                }}<i class="fa fa-chevron-right ms-2"></i>
            </a>
        </div>
    </div>
</section>

<section
    class="fluid-container mt-5 py-5 bg-light"
    *ngIf="registrationEnabled$ | async"
>
    <div class="container text-primary text-center">
        <h2
            class="mb-4"
            [innerHTML]="
                'info-register-' +
                    (phaseService.getCmsAppendString$ | async) +
                    'header'
                    | cmsText
                    | jpText
                    | async
            "
        ></h2>
        <div class="d-grid">
            <button
                class="btn btn-primary btn-lg text-uppercase px-5"
                [disabled]="
                    !(registrationService.enableRegistrationFlow$ | async) ||
                    (isLoadingRegister && registerButtonClicked)
                "
                [routerLink]="'../register'"
                (click)="registerButtonClicked = true"
                gaEvent
                [gaPage]="{
                    path: this.communityService.communityCode + '/home',
                }"
                [gaActivity]="{ category: 'register-button', action: 'click' }"
            >
                <i
                    *ngIf="isLoadingRegister && registerButtonClicked"
                    class="fa fa-spinner fa-spin me-1"
                ></i>
                <span
                    [innerHTML]="
                        'register-' +
                            (phaseService.getCmsAppendString$ | async) +
                            'button-text'
                            | cmsText
                            | jpText
                            | async
                    "
                ></span>
                <i class="fa fa-chevron-right ms-2"></i>
            </button>
        </div>
    </div>
</section>

<div class="py-3">
    <app-socialnetwork-icons></app-socialnetwork-icons>
</div>
